<mat-form-field appearance="fill"
								[class.border-on-right]="borderSide === 'right'"
								[class.border-on-left]="borderSide === 'left'">
	<mat-label [ngClass]="isHighlighted ? 'highlighted': ''">{{ title }}</mat-label>
	<mat-select [disableRipple]="true">
		<mat-option *ngFor="let choice of choices" [routerLink]="[choice.link]">
			{{ choice.label | translate }}
		</mat-option>
	</mat-select>
</mat-form-field>

<div class="highlight-bar" [ngClass]="isHighlighted ? 'highlighted': ''"></div>
